class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('open', () => {
				document.body.classList.add('mobile-nav-open')
			})

			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
				document.body.classList.remove('mobile-nav-open')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)

